<template>
  <!-- 90% da tela (5% de borda para ver a tela por baixo);
       conteúdo metade montagem / metade desenho técnico -->
  <v-dialog
    transition="slide-x-transition"
    persistent
    width="90vw"
    max-width="90vw"
    v-model="opened"
  >
    <v-card
      id="modal-adicionar-produto"
      :color="isDark ? '#0b141a' : '#f2f2f2'"
      :dark="isDark"
      style="height: 90vh; overflow-y: auto; border-radius: 14px;"
    >
      <v-flex xs12>
        <div class="expande-horizontal wrap">
          <v-flex class="pt-3" xs12>
            <div class="expande-horizontal">
              <v-flex xs4>
                <div
                  class="fonte column expande-horizontal pa-6 pt-0 pr-0 font-color"
                >
                  <h3 :style="`color: ${$theme.primary};`">
                    {{ $helper.formataSaldo(product.seller_price || 0) }}
                  </h3>
                  <span class="grey--text fonte-micro">Total da peça</span>
                </div>
              </v-flex>
              <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs2>
                <div
                  class="fonte column expande-horizontal pa-6 pt-0 pl-0 px-3 font-color"
                >
                  <v-img
                    class="cool-shaddow"
                    style="border: 4px solid #f2f2f2; height: 60px; width: 100%; border-radius: 6px;"
                    :src="product.imagens[0]"
                  ></v-img>
                </div>
              </v-flex>
              <v-flex class="pl-0 pt-0 pr-6" xs8>
                <v-autocomplete
                  v-if="changePlate"
                  ref="plateInput"
                  :items="products.filter(p => p.type === 'Placa')"
                  item-text="nome"
                  return-object
                  placeholder="Escolha o novo tipo aqui"
                  @change="alterProduct($event)"
                  outlined
                  hide-details
                  class="mt-1"
                  append-outer-icon="mdi-swap-horizontal"
                  @click:append-outer="changePlate = false"
                ></v-autocomplete>
                <v-list class="pt-0 mt-0" v-else dark color="transparent">
                  <v-list-item
                    class="pa-0 ma-0 pl-3 fonte item-list"
                    :style="`background: ${$theme.primary};`"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="fonte-bold white--text">{{
                        product.nome
                      }}</v-list-item-title>
                      <v-list-item-subtitle class="fonte-micro white--text">
                        {{
                          $helper.formataSaldo(product.ultimo_preco_de_compra)
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <div class="nowrap">
                        <v-btn
                          @click.prevent="initChangeTable"
                          icon
                          class="mr-4"
                        >
                          <v-icon color="#f2f2f2">mdi-swap-horizontal</v-icon>
                        </v-btn>
                        <v-btn @click.prevent="close" icon class="mr-4">
                          <v-icon color="#f2f2f2">mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-flex>
            </div>
            <!-- o scroll fica no card (90vh); aqui o conteúdo flui -->
            <v-flex
              xs12
              class="pl-3 pr-3 pt-2 pb-2 adicionals fonte"
            >
              <!-- METADE/METADE: montagem (esquerda) e desenho técnico (direita) -->
              <div
                v-if="product.ficha_tecnica ? true : false"
                class="expande-horizontal wrap"
                style="align-items: flex-start;"
              >
                <v-flex xs12 md6 class="pr-2">
                  <div class="expande-horizontal">
                    <v-flex xs12>
                      <v-timeline class="ml-0 pl-0" dense align-top>
                        <v-timeline-item
                          icon-color="#f2f2f2"
                          icon="mdi-tag-heart-outline"
                          :color="$theme.primary"
                        >
                          <div v-if="get_compra.obra" class="room-selection-stage">
                            <div class="room-selection-heading">
                              <div class="room-selection-heading-copy">
                                <span class="room-selection-eyebrow">Ambiente da obra</span>
                                <strong>{{ get_compra.obra.nome }}</strong>
                                <small>Escolha onde esta peça será instalada.</small>
                              </div>
                              <v-avatar size="42" :color="isDark ? '#173b33' : '#e8f6ee'">
                                <v-icon :color="$theme.primary">mdi-home-floor-1</v-icon>
                              </v-avatar>
                            </div>
                            <div v-if="roomOptions.length" class="room-selection-grid">
                              <button
                                v-for="(room, roomIndex) in roomOptions"
                                :key="`room-card-${room.key}`"
                                type="button"
                                class="room-selection-card"
                                :class="{ 'room-selection-card-selected': isRoomSelected(room) }"
                                :style="{ '--room-index': roomIndex }"
                                :aria-pressed="isRoomSelected(room)"
                                @click="selectRoom(room)"
                              >
                                <span class="room-selection-card-glow"></span>
                                <span class="room-selection-card-icon">
                                  <v-icon size="22">{{ room.icon }}</v-icon>
                                </span>
                                <span class="room-selection-card-copy">
                                  <strong>{{ room.label }}</strong>
                                  <small>{{ isRoomSelected(room) ? 'Selecionado' : 'Selecionar cômodo' }}</small>
                                </span>
                                <v-icon
                                  v-if="isRoomSelected(room)"
                                  class="room-selection-card-check"
                                  color="green"
                                  size="20"
                                >mdi-check-circle</v-icon>
                              </button>
                            </div>
                            <div v-else class="room-selection-empty">
                              <v-icon size="20">mdi-home-alert-outline</v-icon>
                              <span>Cadastre os cômodos na obra para organizar esta peça.</span>
                            </div>
                          </div>
                          <!-- <v-text-field
                            label="Descrição da peça"
                            autofocus
                            id="campo-descricao-peca"
                            :color="$theme.primary"
                            v-model="product.descricao_personalizada"
                          ></v-text-field> -->
                        </v-timeline-item>
                        <v-timeline-item
                          icon-color="#f2f2f2"
                          icon="mdi-ruler-square"
                          :color="$theme.primary"
                        >
                          <v-text-field
                            hide-details
                            dense
                            v-if="product.descricao_personalizada"
                            v-model="product.descricao_personalizada"
                            label="Monte a peça abaixo"
                          ></v-text-field>
                          <h3 class="mb-0 pb-0" v-if="!product.descricao_personalizada">{{ product.descricao_personalizada ? product.descricao_personalizada : 'Monte a peça abaixo' }}</h3>
                          <!-- <span class="grey--text" v-if="product.descricao_personalizada">Montando: {{ product.descricao_personalizada }}</span> -->
                          <!-- itens da ficha: fundo/texto acompanham o tema -->
                          <v-list
                            v-if="product.ficha_tecnica"
                            class="fonte px-0 mx-0"
                            id="lista-de-partes"
                            dense
                            nav
                            two-line
                            :dark="isDark"
                            color="transparent"
                          >
                            <v-list-item
                              v-for="(item, i) in product.ficha_tecnica"
                              :key="`ficha-tecnica-${i}`"
                              :class="{ 'ficha-selected': selectedPieceIndex === i }"
                              :style="
                                selectedPieceIndex === i
                                  ? (isDark ? 'background: rgba(37,211,102,0.14);' : 'background: rgba(18,140,126,0.10);')
                                  : (isDark ? 'background: #182229;' : 'background: #fff;')
                              "
                              @click="selectPiece(i)"
                            >
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span
                                    style="font-size: 13pt;"
                                    class="font-weight-bold"
                                    >{{ item.quantity }}
                                  </span>
                                  <span class="fonte" style="font-size: 12pt;">
                                    {{ item.descricao }}
                                  </span>
                                  <span
                                    v-if="
                                      item.type !== 'Acabamento' &&
                                        $vuetify.breakpoint.smAndUp
                                    "
                                  >
                                    <v-chip
                                      :color="$theme.primary"
                                      small
                                      style="border-radius: 3px;"
                                      class="white--text"
                                    >
                                      <span class="fonte-weight-bold ">
                                        {{
                                          formatMeasure(item.comprimento)
                                        }}
                                        x
                                        {{
                                          formatMeasure(item.largura)
                                        }}
                                        {{ verifyUnit(item) }}
                                      </span>
                                    </v-chip>
                                  </span>
                                  <v-chip
                                    v-if="$vuetify.breakpoint.smAndUp"
                                    color="green"
                                    small
                                    style="border-radius: 3px;"
                                    class="mx-1 white--text"
                                    >{{
                                      $helper.formataSaldo(item.total || 0)
                                    }}</v-chip
                                  >
                                  <v-chip
                                    :color="$theme.secondary"
                                    small
                                    style="border-radius: 3px;"
                                    class="white--text"
                                    >{{ item.type }}</v-chip
                                  >
                                </v-list-item-title>
                                <v-list-item-subtitle
                                  v-if="$vuetify.breakpoint.smAndDown"
                                >
                                  <span
                                    v-if="
                                      item.type !== 'Acabamento' &&
                                        $vuetify.breakpoint.smAndDown
                                    "
                                  >
                                    <v-chip
                                      :color="$theme.primary"
                                      small
                                      class="black--text"
                                    >
                                      {{
                                        formatMeasure(item.comprimento)
                                      }}
                                      x
                                      {{ formatMeasure(item.largura) }}
                                      {{ verifyUnit(item) }}</v-chip
                                    >
                                    <v-chip
                                      color="green"
                                      small
                                      rounded
                                      class="mx-1 white--text"
                                      >{{
                                        $helper.formataSaldo(item.total || 0)
                                      }}</v-chip
                                    >
                                  </span>
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-if="hasMissingDimensions(item)"
                                  class="pt-1"
                                >
                                  <div class="expande-horizontal">
                                    <v-flex xs5 class="pr-1">
                                      <v-text-field
                                        dense
                                        hide-details
                                        outlined
                                        label="Comp."
                                        v-model="item.comprimento"
                                        @change="updateFichaItem(item, i)"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 class="pl-1">
                                      <v-text-field
                                        dense
                                        hide-details
                                        outlined
                                        label="Larg."
                                        v-model="item.largura"
                                        @change="updateFichaItem(item, i)"
                                      ></v-text-field>
                                    </v-flex>
                                  </div>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <div class="expande-horizontal column">
                                  <v-btn
                                    @click.stop="removeItem(item, i)"
                                    x-small
                                    text
                                    color="grey"
                                    v-if="$vuetify.breakpoint.smAndUp"
                                    >remover</v-btn
                                  >
                                  <v-btn
                                    @click.stop="removeItem(item, i)"
                                    x-small
                                    text
                                    color="grey"
                                    v-else
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </div>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                          <!-- o desenho técnico fica FORA da timeline (abaixo),
                               em largura total — a coluna aqui é estreita demais -->
                        </v-timeline-item>
                      </v-timeline>
                    </v-flex>
                  </div>
                </v-flex>
                <!-- DESENHO TÉCNICO na METADE DIREITA do modal: o atendente
                     monta a peça visualmente (copilot, acabamentos, furos).
                     Toda mudança recalcula via processFinalPrice. -->
                <v-flex
                  v-if="(product.ficha_tecnica || []).length"
                  xs12
                  md6
                  class="mb-2 pl-2"
                >
                  <div
                    class="modal-drawing-card"
                    :class="{
                      'modal-drawing-card--expanded': drawingExpanded,
                      'modal-drawing-card--dark': isDark
                    }"
                  >
                    <!-- em tela cheia o board tem seu PRÓPRIO cabeçalho
                         (título + toolbar) — este daqui some pra não
                         duplicar o título "Desenho técnico" -->
                    <div v-show="!drawingExpanded" class="modal-drawing-head">
                      <span
                        class="fonte font-weight-bold"
                        :style="`font-size: 12pt; color: ${isDark ? '#e9edef' : '#173b33'};`"
                      >
                        <v-icon size="18" :color="isDark ? '#e9edef' : '#173b33'">mdi-ruler-square-compass</v-icon>
                        Desenho técnico
                      </span>
                      <v-spacer />
                      <v-btn
                        icon
                        small
                        :title="drawingExpanded ? 'Restaurar tamanho' : 'Expandir desenho'"
                        @click="drawingExpanded = !drawingExpanded"
                      >
                        <v-icon size="20">{{ drawingExpanded ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                      </v-btn>
                    </div>
                    <StoneTechnicalDrawing2D
                      :key="`modal-drawing-${drawingExpanded}`"
                      :items="product.ficha_tecnica"
                      :selected-index="selectedPieceIndex"
                      :tax-finishing="taxFinishing"
                      :slab-thickness-mm="plateThicknessMm()"
                      :item-recalculator="recalcDrawingItem"
                      :finish-catalog="drawingFinishCatalog"
                      :secondary-catalog="drawingSecondaryCatalog"
                      :cutout-catalog="drawingCutoutCatalog"
                      :drawing-elements="modalDrawingExtras.elements"
                      :drawing-annotations="modalDrawingExtras.annotations"
                      :drawing-images="modalDrawingExtras.images"
                      :height="drawingExpanded ? 640 : 540"
                      @select-item="selectPiece"
                      @update:items="onDrawingItemsUpdate"
                      @add-element="onModalDrawingAdd('elements', $event)"
                      @update-element="onModalDrawingUpdate('elements', $event)"
                      @remove-element="onModalDrawingRemove('elements', $event)"
                      @add-annotation="onModalDrawingAdd('annotations', $event)"
                      @update-annotation="onModalDrawingUpdate('annotations', $event)"
                      @remove-annotation="onModalDrawingRemove('annotations', $event)"
                      @add-image="onModalDrawingAdd('images', $event)"
                      @update-image="onModalDrawingUpdate('images', $event)"
                      @remove-image="onModalDrawingRemove('images', $event)"
                      @replace-extras="onModalReplaceExtras"
                      @notify="msg => createGlobalMessage({ type: msg.type || 'info', message: msg.message, timeout: 4000 })"
                    >
                      <template v-slot:board-actions>
                        <v-btn
                          v-if="drawingExpanded"
                          icon
                          small
                          title="Restaurar tamanho"
                          @click="drawingExpanded = false"
                        >
                          <v-icon size="20">mdi-arrow-collapse</v-icon>
                        </v-btn>
                      </template>
                    </StoneTechnicalDrawing2D>
                  </div>
                </v-flex>
                <div class="expande-horizontal">
                  <v-flex v-if="false" xs12>
                    <v-simple-table
                      dark
                      style="witdh: 100%; height: 370px; overflow: auto; background: #f0f0f0;"
                      dense
                    >
                      <template v-slot:default>
                        <thead style="background: #EBEBEB; height: 40px;">
                          <tr
                            style="background: #EBEBEB; border: 1px solid #f0f0f0;"
                          >
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Qtd
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Desc.
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Comprimento
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Largura
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Medida
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            >
                              Preço
                            </td>
                            <td
                              class="font-weight-bold fonte"
                              style="color: #878686; border-right: 1px solid #D2D4CF;"
                            ></td>
                          </tr>
                        </thead>
                        <tbody>
                          <template v-for="(item, i) in product.ficha_tecnica">
                            <tr
                              class="mt-3"
                              @click="openModalAddProduct(item, `${i}`)"
                              style="background: #f0f0f0; cursor: pointer; border: 1px solid #f0f0f0;"
                              :key="`product-inn-list-${i}`"
                            >
                              <td
                                @click.prevent="abre_modal_view_caixa(item)"
                                style="color: #878686; width: 10px; border-top: 1px dashed #D2D4CF;"
                                class="fonte fonte-bold"
                              >
                                {{ item.quantity }}
                              </td>
                              <td
                                class="fonte fonte-bold"
                                style="color: #494949; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                {{ item.descricao ? item.descricao : "" }}
                              </td>
                              <td
                                class="fonte fonte-bold"
                                style="color: #878686; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                {{ item.comprimento ? item.comprimento : "" }}
                              </td>
                              <td
                                class="fonte fonte-bold"
                                style="color: #878686; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                {{ item.largura ? item.largura : "" }}
                              </td>
                              <td
                                class="fonte fonte-bold"
                                style="color: #878686; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                {{ verifyUnit(item) }}
                              </td>
                              <td
                                class="fonte green--text fonte-bold"
                                style="color: #878686; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                {{ $helper.formataSaldo(item.total) }}
                              </td>
                              <td
                                class="fonte green--text fonte-bold"
                                style="color: #878686; border-top: 1px dashed #D2D4CF;"
                                @click.prevent="abre_modal_view_caixa(item)"
                              >
                                <v-btn @click="removeItem(item, i)" icon small>
                                  <v-icon color="red lighten-2">
                                    mdi-delete-circle-outline
                                  </v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-flex>
                </div>
              </div>
              <v-flex v-if="isPieceCatalogIncomplete" xs12 class="mb-3">
                <v-card class="piece-empty-state pa-4" outlined>
                  <div class="expande-horizontal wrap align-center">
                    <v-flex xs12 md8>
                      <div class="expande-horizontal column">
                        <span class="fonte font-weight-bold">
                          Cadastre pecas base para montar a ficha
                        </span>
                        <span class="fonte grey--text">
                          Cadastre pelo menos uma peca principal e uma secundaria para agilizar a montagem.
                        </span>
                        <div class="mt-2">
                          <v-chip
                            small
                            class="mr-1 mb-1"
                            :color="hasPrincipalPieceTemplate ? 'green' : 'grey lighten-2'"
                            :text-color="hasPrincipalPieceTemplate ? 'white' : 'black'"
                          >
                            Peca principal
                          </v-chip>
                          <v-chip
                            small
                            class="mr-1 mb-1"
                            :color="hasSecondaryPieceTemplate ? 'green' : 'grey lighten-2'"
                            :text-color="hasSecondaryPieceTemplate ? 'white' : 'black'"
                          >
                            Peca secundaria
                          </v-chip>
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs12 md4 class="text-md-right mt-3 mt-md-0">
                      <v-btn
                        color="#1d4ed8"
                        dark
                        class="text-none"
                        @click="openPieceTemplateOnboarding(firstMissingPieceType)"
                      >
                        Cadastrar peca
                        <v-icon right size="18">mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </v-flex>
                  </div>
                </v-card>
              </v-flex>
              <v-form ref="formAddItem">
                <div class="expande-horizontal wrap centraliza pt-2">
                  <v-flex
                  style="min-height: 100px;"
                  xs4 md1>
                    <v-text-field
                      label="Qtd"
                      ref="qtdFicha"
                      outlined
                      hide-details
                      id="quantidade-da-peca"
                      dense
                      :rules="[v => !!v || 'Preencha este campo']"
                      @keyup.enter.prevent="() => $refs.typeField.focus()"
                      v-mask="['#', '##', '###', '####']"
                      v-model="quantidade"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    :class="{
                      'pr-0': $vuetify.breakpoint.smAndDown
                    }"
                    id="peca-do-cadastro"
                    style="min-height: 100px;"
                    class="px-3"
                    xs8
                    md5
                  >
                    <v-autocomplete
                      label="Tipo"
                      ref="typeField"
                      :items="adicionais"
                      item-text="nome"
                      no-data-text="Nenhuma peca encontrada"
                      outlined
                      hide-details
                      dense
                      return-object
                      append-outer-icon="mdi-plus-circle-outline"
                      @click:append-outer="openPieceTemplateOnboarding(firstMissingPieceType)"
                      v-model="descricao"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex
                    v-if="descricao && !['Acabamento', 'Forma Pronta'].includes(descricao.type)"
                    xs5
                    md2
                    style="min-height: 100px;"
                  >
                    <v-text-field
                      ref="compField"
                      label="Comprimento"
                      placeholder="Ex.: 2,705"
                      suffix="m"
                      id="comprimento-peca"
                      v-mask="['#,###', '##,###']"
                      outlined
                      hide-details
                      dense
                      v-model="comprimento"
                    ></v-text-field>
                  </v-flex>
                  <v-icon
                    v-if="descricao && !['Acabamento', 'Forma Pronta'].includes(descricao.type)"
                    class="px-1 mb-9"
                    color="#666"
                    >mdi-close</v-icon>
                  <!-- <span
                    v-if="descricao && !['Acabamento', 'Forma Pronta'].includes(descricao.type)"
                    class="px-4"
                    >x</span
                  > -->
                  <v-flex
                    v-if="descricao && !['Acabamento', 'Forma Pronta'].includes(descricao.type)"
                    xs5
                    md2
                    style="min-height: 100px;"
                  >
                    <v-text-field
                      label="Largura"
                      placeholder="Ex.: 0,605"
                      suffix="m"
                      v-mask="['#,###', '##,###']"
                      outlined
                      id="largura-peca"
                      hide-details
                      dense
                      v-model="largura"
                      @keyup.enter="addFichaTecnica"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                  style="min-height: 100px;"

                  id="adicionar-peca" v-if="descricao" class="pt-1 pl-1" xs1>
                    <v-avatar size="32" :color="$theme.primary">
                      <v-btn @click="addFichaTecnica" icon>
                        <v-icon color="#f2f2f2">mdi-plus</v-icon>
                      </v-btn>
                    </v-avatar>
                  </v-flex>
                </div>
              </v-form>
              <!-- <div class="expande-horizontal">
                <v-flex xs2>
                  <v-text-field
                    label="Quantidade"
                    type="number"
                    min="0"
                    v-mask="['#', '##', '###', '####']"
                    v-model="quantidadeAd"
                  ></v-text-field>
                </v-flex>
                <v-flex class="px-3 cl" xs6>
                  <v-autocomplete
                    label="Adicional"
                    :items="adicionais"
                    item-text="nome"
                    return-object
                    v-model="adicional"
                  ></v-autocomplete>
                </v-flex>
                <v-flex class="pt-2" xs3>
                  <v-btn @click="addFichaTecnica('adicional')" icon>
                    <v-icon :color="$theme.third"
                      >mdi-plus-circle-outline</v-icon
                    >
                  </v-btn>
                </v-flex>
              </div> -->
              <div class="expande-horizontal wrap">
                <v-flex xs12>
                  <v-list
                    class="pa-0 ma-0"
                    v-for="(adicional, index) in product.adicionais"
                    :id="`aditional_${index}`"
                    :key="adicional.nome_grupo"
                  >
                    <v-list-item class="pa-0 ma-0 pl-3 fonte item-list">
                      <v-list-item-content>
                        <v-list-item-title class="pb-1 fonte-bold">
                          {{ adicional.nome_grupo }}
                          <v-btn
                            outlined
                            class="ml-3"
                            :color="
                              adicional.obrigatorio ? 'red darken-2' : 'grey'
                            "
                            x-small
                            dark
                            >{{
                              adicional.obrigatorio ? "obrigatório" : "opcional"
                            }}</v-btn
                          >
                        </v-list-item-title>
                        <v-list-item-subtitle class="fonte-micro">
                          {{ adicional.quantidade_adicionada || 0 }} de
                          {{ adicional.maximo }} itens adicionados
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <template v-for="(item_adicional, i) in adicional.itens">
                      <v-list-item class="fonte" :key="item_adicional.nome">
                        <v-list-item-content>
                          <v-list-item-title class="fonte">
                            {{
                              item_adicional.descricao_personalizada
                                ? item_adicional.descricao_personalizada
                                : item_adicional.nome
                            }}
                          </v-list-item-title>
                          <v-list-item-subtitle
                            class="fonte fonte-bold green--text"
                          >
                            + {{ $helper.formataSaldo(item_adicional.preco) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <div class="expande-horizontal">
                            <v-btn
                              @click.prevent="removeAditional(i, index)"
                              v-if="
                                item_adicional &&
                                  item_adicional.quantidade_adicionada > 1
                              "
                              icon
                              x-small
                            >
                              <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                            <v-btn
                              @click.prevent="removeAditional(i, index)"
                              v-if="
                                item_adicional &&
                                  item_adicional.quantidade_adicionada === 1
                              "
                              icon
                              x-small
                            >
                              <v-icon>mdi-delete-circle-outline</v-icon>
                            </v-btn>
                            <h5 class="mx-2 fonte fonte-bold">
                              {{ item_adicional.quantidade_adicionada || 0 }}
                            </h5>
                            <v-btn @click="addAditional(i, index)" icon x-small>
                              <v-icon color="green"
                                >mdi-plus-circle-outline</v-icon
                              >
                            </v-btn>
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-flex>
                <!-- <v-flex class="pt-6" xs12>
                  <v-textarea
                    height="100px"
                    @keyup.enter.prevent="addProduct"
                    hint="Pressione enter para adicionar rapidamente"
                    v-model="product.obs"
                    label="Observações"
                  ></v-textarea>
                </v-flex> -->
              </div>
            </v-flex>
            <div
              class="expande-horizontal wrap column centraliza px-2"
            >
              <!-- <v-btn
                @click.prevent="removeProductQtd"
                v-if="product.quantity > 1"
                icon
                small
              >
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
              <v-btn
                @click.prevent="removeProductOfCart(product)"
                v-if="product.quantity === 1"
                icon
                small
              >
                <v-icon>mdi-delete-circle-outline</v-icon>
              </v-btn>
              <h3 class="mx-2 fonte fonte-bold">
                {{ product.quantity }}
              </h3> -->
              <!-- <v-btn @click="addProductQtd" icon small>
                <v-icon color="green">mdi-plus-circle-outline</v-icon>
              </v-btn> -->

              <div id="acoes-modal-adicionar" class="expande-horizontal centraliza">
                <v-btn
                  @click.prevent="addProduct(true)"
                  :color="$theme.primary"
                  :disabled="product.ficha_tecnica.length === 0 ? true : false"
                  class="fonte mx-1 elevation-0 white--text my-2"
                  dark
                  small
                  rounded
                >
                  Adicionar sequencia
                </v-btn>
                <v-btn
                  @click.prevent="addProduct(false)"
                  :color="$theme.primary"
                  :disabled="product.ficha_tecnica.length === 0 ? true : false"
                  class="fonte elevation-0 white--text my-2"
                  dark
                  small
                  rounded
                >
                  Adicionar ao orçamento
                </v-btn>
              </div>
              <v-btn
                @click.prevent="removeProductOfCart(product)"
                v-if="product.quantity >= 1"
                color="red lighten"
                :disabled="product.ficha_tecnica.length === 0 ? true : false"
                class="fonte elevation-0 white--text my-2"
                dark
                outlined
                x-small
                rounded
              >
                Cancelar/Remover
              </v-btn>
            </div>
          </v-flex>
        </div>
      </v-flex>
      <v-dialog
        v-model="pieceTemplateDialog"
        :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '560px'"
        persistent
      >
        <v-card
          class="piece-onboarding-card"
          :class="{ 'piece-onboarding-card-dark': isDark, 'piece-onboarding-card-light': !isDark }"
        >
          <v-card-title class="pb-1">
            <div class="expande-horizontal column">
              <span class="fonte font-weight-bold">Cadastro rapido de peca</span>
              <span class="fonte grey--text">Monte a ficha mais rapido no atendimento</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePieceTemplateOnboarding">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4 pb-2">
            <div v-if="pieceTemplateStep === 1">
              <v-form ref="pieceTemplateForm" lazy-validation>
                <v-select
                  v-model="quickPieceTemplateForm.type"
                  :items="['Peça Principal', 'Peça Secundária']"
                  dense
                  outlined
                  label="Tipo de peca"
                  :rules="[v => !!v || 'Selecione o tipo']"
                ></v-select>
                <v-text-field
                  v-model="quickPieceTemplateForm.nome"
                  dense
                  outlined
                  label="Nome da peca"
                  placeholder="Ex: Saia frontal"
                  :rules="[v => !!v || 'Informe o nome da peca']"
                ></v-text-field>
              </v-form>
            </div>

            <div v-if="pieceTemplateStep === 2" class="text-center">
              <v-avatar size="58" class="piece-success-avatar mb-3">
                <v-icon class="piece-success-icon" size="30">mdi-check-decagram</v-icon>
              </v-avatar>
              <h3 class="fonte mb-2">Peca cadastrada com sucesso</h3>
              <p class="fonte grey--text mb-0">Deseja cadastrar outra peca agora?</p>
            </div>

            <div v-if="pieceTemplateStep === 3" class="text-center">
              <v-avatar size="58" class="piece-info-avatar mb-3">
                <v-icon class="piece-info-icon" size="30">mdi-information-outline</v-icon>
              </v-avatar>
              <h3 class="fonte mb-2">Perfeito</h3>
              <p class="fonte grey--text mb-0">
                Agora voce pode montar fichas no atendimento com mais rapidez.
              </p>
            </div>
          </v-card-text>
          <v-card-actions class="pa-4 pt-1">
            <v-spacer></v-spacer>
            <template v-if="pieceTemplateStep === 1">
              <v-btn
                text
                class="text-none"
                :disabled="savingPieceTemplate"
                @click="closePieceTemplateOnboarding"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="#1d4ed8"
                dark
                class="text-none"
                :loading="savingPieceTemplate"
                @click="createPieceTemplate"
              >
                Salvar peca
              </v-btn>
            </template>
            <template v-if="pieceTemplateStep === 2">
              <v-btn text color="#325286" class="text-none" @click="goToPieceTemplateFinalStep">
                Sair
              </v-btn>
              <v-btn color="#1d4ed8" dark class="text-none" @click="startAnotherPieceTemplate">
                Cadastrar outra
              </v-btn>
            </template>
            <template v-if="pieceTemplateStep === 3">
              <v-btn color="#1d4ed8" dark class="text-none" @click="closePieceTemplateOnboarding">
                Entendi
              </v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex/dist/vuex.common.js";
import { recalculateItem } from "@/apps/shared/services/fichaPricing";
import StoneTechnicalDrawing2D from "@/components/stone-technical-drawing/StoneTechnicalDrawing2D.vue";
import { uid } from "@/components/stone-technical-drawing/engine/drawing/annotationUtils";
import { DEFAULT_METERS_TO_PX } from "@/components/stone-technical-drawing/engine/drawing/scaleUtils";
import {
  formatMeasure as formatMeters,
  parseMeasure,
  roundMeasure
} from "@/apps/shared/utils/measurements";
export default {
  components: { StoneTechnicalDrawing2D },
  props: {
    addProductToCart: {
      type: Function,
      required: true
    },
    removeProductOfCart: {
      type: Function,
      required: true
    },
    products: {
      type: Array,
      default: () => [],
      required: true
    },
    taxFinishing: {
      type: Number,
      required: true,
      default: 30
    }
  },
  data() {
    return {
      changePlate: false,
      opened: false,
      // desenho técnico do modal em tela cheia
      drawingExpanded: false,
      cadViewMode: "2d",
      selectedReadyForm: null,
      selectedPieceIndex: null,
      hoverPrimaryIndex: null,
      edgePositions: [
        { key: "front", label: "Frente" },
        { key: "back", label: "Fundo" },
        { key: "left", label: "Esq." },
        { key: "right", label: "Dir." }
      ],
      edgeFinishTypes: [
        { value: "polida", label: "Polida reta" },
        { value: "boleada", label: "Boleada" },
        { value: "bisote", label: "Bisote" },
        { value: "meia-esquadria", label: "Meia esquadria" },
        { value: "chanfrada", label: "Chanfrada" },
        { value: "pingadeira", label: "Pingadeira" }
      ],
      pieceTemplateDialog: false,
      pieceTemplateStep: 1,
      savingPieceTemplate: false,
      quickPieceTemplateForm: {
        nome: "",
        type: "Peça Principal"
      },
      product: {
        quantity: 1,
        imagens: [],
        ficha_tecnica: [],
        obra: null,
        comodo: null
      },
      adicional: "",
      quantidade: "",
      quantidadeAd: "",
      comprimento: "",
      largura: "",
      descricao: "",
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4"
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"]
    };
  },
  methods: {
    toNumber(value) {
      return parseMeasure(value);
    },
    plateThicknessMm(product = this.product) {
      const raw =
        product.slabThicknessMm ||
        product.espessura_mm ||
        product.espessuraMm ||
        product.grossura_mm ||
        product.grossuraMm;
      const value = this.toNumber(raw);
      return value > 0 ? value : 10;
    },
    withPlateThickness(item, product = this.product) {
      const slabThicknessMm = this.plateThicknessMm(product);
      return {
        ...item,
        slabThicknessMm,
        espessura_mm: slabThicknessMm,
        espessuraMm: slabThicknessMm
      };
    },
    normalizeType(type) {
      return `${type || ""}`
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    formatMeasure(value) {
      return formatMeters(value);
    },
    getTechnicalPieceLabel(item, index) {
      const prefix = this.normalizeType(item.type).includes("acabamento")
        ? "AC"
        : this.isPrimaryPiece(item)
          ? "P"
          : "S";
      return `${prefix}${index + 1} - ${item.quantity || 1}x`;
    },
    ensureEdgeFinish(item) {
      if (!item) return;
      if (!item.edgeFinishType) {
        this.$set(item, "edgeFinishType", "polida");
      }
      if (!Array.isArray(item.edgeFinishes)) {
        this.$set(item, "edgeFinishes", []);
      }
    },
    hasEdgeFinish(item, edge) {
      return Array.isArray(item && item.edgeFinishes) && item.edgeFinishes.includes(edge);
    },
    toggleEdgeFinish(item, edge) {
      this.ensureEdgeFinish(item);
      const finishes = [...item.edgeFinishes];
      const index = finishes.indexOf(edge);
      if (index >= 0) {
        finishes.splice(index, 1);
      } else {
        finishes.push(edge);
      }
      this.$set(item, "edgeFinishes", finishes);
    },
    isStonePiece(type) {
      const normalized = this.normalizeType(type);
      return (
        normalized.includes("peca principal") ||
        normalized.includes("peca secundaria")
      );
    },
    isPrimaryPiece(item) {
      return this.normalizeType(item && item.type).includes("peca principal");
    },
    handlePieceHover(index, item) {
      this.hoverPrimaryIndex = this.isPrimaryPiece(item) ? index : null;
    },
    ensurePosition(item, index) {
      if (!item.position) {
        this.$set(item, "position", {
          x: Math.min(90, 18 + (index % 5) * 12),
          y: Math.min(84, 20 + (index % 5) * 9),
          z: 0
        });
      }
      if (this.isStonePiece(item.type)) {
        this.ensureEdgeFinish(item);
      }
      return item.position;
    },
    selectPiece(index) {
      this.selectedPieceIndex = index;
      if (this.product.ficha_tecnica[index]) {
        this.ensurePosition(this.product.ficha_tecnica[index], index);
      }
    },
    roomSelectionValue(room) {
      if (room && typeof room === "object") {
        return room.nome || room.name || room.label || room.value || "";
      }
      return room || "";
    },
    roomIcon(room) {
      const normalized = this.normalizeType(this.roomSelectionValue(room));
      if (normalized.includes("cozinha")) return "mdi-stove-outline";
      if (normalized.includes("banheiro") || normalized.includes("lavabo")) return "mdi-shower-head";
      if (normalized.includes("sala")) return "mdi-sofa-outline";
      if (normalized.includes("quarto")) return "mdi-bed-king-outline";
      if (normalized.includes("varanda") || normalized.includes("sacada")) return "mdi-flower-outline";
      if (normalized.includes("escritorio") || normalized.includes("escritório")) return "mdi-desk";
      return "mdi-floor-plan";
    },
    isRoomSelected(room) {
      return this.roomSelectionValue(this.product.comodo) === room.value;
    },
    selectRoom(room) {
      this.$set(this.product, "comodo", room.value);
    },
    syncRoomSelection() {
      if (!this.product.comodo) return;
      if (!this.roomOptions.length || !this.roomOptions.some(room => this.isRoomSelected(room))) {
        this.$set(this.product, "comodo", null);
      }
    },
    getPieceStyle(item, index, mode) {
      const position = this.ensurePosition(item, index);
      const isFinish = this.normalizeType(item.type).includes("acabamento");
      const comprimento = this.toNumber(item.comprimento);
      const largura = this.toNumber(item.largura);
      const width = isFinish ? 26 : Math.max(35, Math.min(160, comprimento * 40));
      const height = isFinish
        ? 26
        : Math.max(20, Math.min(90, (largura <= 0.1 ? 0.25 : largura) * 70));
      const baseStyle = {
        width: `${width}px`,
        height: `${height}px`,
        left: `${position.x}%`,
        top: `${position.y}%`,
        background: isFinish
          ? "#1f8a70"
          : this.normalizeType(item.type).includes("secundaria")
            ? "#2d6cdf"
            : "#5a3b2e"
      };
      if (mode === "3d") {
        return {
          ...baseStyle,
          transform: `translate(-50%, -50%) translateZ(${position.z || 0}px)`
        };
      }
      return {
        ...baseStyle,
        transform: "translate(-50%, -50%)"
      };
    },
    // Peça Secundária adicionada pelo FORMULÁRIO também nasce colada e
    // paralela à primeira Peça Principal (mesma regra do copilot), conforme
    // a relação do cadastro: curvada p/ baixo => embaixo; p/ cima => em
    // cima; sobreposta => centrada. Também vincula (linkedTo) para mover
    // junto e a perspectiva desenhar certo.
    placementForSecondary(larguraM, relacao) {
      const ficha = this.product.ficha_tecnica || [];
      const principal = ficha.find(f => this.isPrimaryPiece(f));
      if (!principal) return null;
      if (!principal.position) {
        this.$set(principal, "position", { x: 50, y: 45, z: 0 });
      }
      if (!principal.fichaId) {
        this.$set(principal, "fichaId", uid("ficha"));
      }
      const canvasH = this.drawingExpanded ? 640 : 540;
      const visualHalfPx = largura => {
        const meters = Math.max(this.toNumber(largura) || 0.1, 0.1);
        return Math.max((meters * DEFAULT_METERS_TO_PX) / 2, 4);
      };
      const dyPct =
        ((visualHalfPx(principal.largura) + visualHalfPx(larguraM) + 16) /
          canvasH) *
        100;
      const pos = {
        x: Number(principal.position.x) || 50,
        y: Number(principal.position.y) || 45,
        z: 0
      };
      let edge = "front";
      if (relacao === "curva_cima") {
        pos.y -= dyPct;
        edge = "back";
      } else if (
        relacao === "sobreposta_acima" ||
        relacao === "sobreposta_abaixo"
      ) {
        edge = null; // centrada sobre a principal
      } else {
        pos.y += dyPct;
      }
      pos.y = Math.max(0, Math.min(100, pos.y));
      return {
        position: pos,
        linkedTo: { parentId: principal.fichaId, edge }
      };
    },

    // ===== desenho técnico embutido no modal =====
    // recálculo injetado no engine: usa o preço da placa do produto atual
    // e a taxFinishing da config — mesma fórmula do orçamento.
    recalcDrawingItem(item) {
      const platePrice = this.toNumber(this.product.ultimo_preco_de_compra);
      return this.recalculateItemTotal(item, platePrice);
    },
    // qualquer mudança vinda do desenho (resize, saia, acabamento na borda,
    // recorte...) grava a ficha e REFAZ o preço final do produto.
    onDrawingItemsUpdate(nextFicha) {
      this.product.ficha_tecnica = nextFicha;
      this.processFinalPrice();
    },
    ensureModalExtras() {
      if (!this.product.drawingExtras) {
        this.$set(this.product, "drawingExtras", {
          schemaVersion: 2,
          elements: [],
          annotations: [],
          images: []
        });
      }
      return this.product.drawingExtras;
    },
    onModalDrawingAdd(layer, entity) {
      const extras = this.ensureModalExtras();
      if (!Array.isArray(extras[layer])) this.$set(extras, layer, []);
      extras[layer].push(entity);
    },
    onModalDrawingUpdate(layer, { id, patch }) {
      const extras = this.ensureModalExtras();
      const idx = (extras[layer] || []).findIndex(e => e.id === id);
      if (idx >= 0) {
        this.$set(extras[layer], idx, { ...extras[layer][idx], ...patch });
      }
    },
    onModalDrawingRemove(layer, { id }) {
      const extras = this.ensureModalExtras();
      this.$set(
        extras,
        layer,
        (extras[layer] || []).filter(e => e.id !== id)
      );
    },
    onModalReplaceExtras({ elements, annotations, images }) {
      const extras = this.ensureModalExtras();
      this.$set(extras, "elements", Array.isArray(elements) ? elements : []);
      this.$set(extras, "annotations", Array.isArray(annotations) ? annotations : []);
      this.$set(extras, "images", Array.isArray(images) ? images : []);
    },

    // fórmula centralizada em fichaPricing.js (compartilhada com o editor
    // de desenho técnico da venda)
    recalculateItemTotal(item, platePrice) {
      return recalculateItem(item, {
        platePrice,
        taxFinishing: this.taxFinishing,
        resolveFinishingPrice: fichaItem => {
          const acabamento = this.products.find(
            product =>
              this.normalizeType(product.type).includes("acabamento") &&
              `${product.nome || ""}`.toLowerCase() ===
                `${fichaItem.descricao || ""}`.toLowerCase()
          );
          return acabamento ? acabamento.ultimo_preco_de_compra : 0;
        }
      });
    },
    applyReadyForm(readyForm) {
      if (!readyForm) return;
      const platePrice = this.toNumber(this.product.ultimo_preco_de_compra);
      const ficha = (readyForm.ficha_tecnica || []).map((item, index) => {
        const recalculated = this.recalculateItemTotal(
          this.withPlateThickness(
            {
              ...item,
              quantity: parseInt(item.quantity) || 1,
              edgeFinishType: item.edgeFinishType || "polida",
              edgeFinishes: Array.isArray(item.edgeFinishes) ? item.edgeFinishes : [],
              // recortes/silhueta do template (cuba, cooktop, L/U) passam junto
              cutouts: Array.isArray(item.cutouts) ? item.cutouts : [],
              position: item.position || {
                x: Math.min(90, 18 + (index % 5) * 12),
                y: Math.min(84, 20 + (index % 5) * 9),
                z: 0
              }
            },
            this.product
          ),
          platePrice
        );
        return recalculated;
      });
      this.product.ficha_tecnica = ficha;
      if (!this.product.descricao_personalizada) {
        this.product.descricao_personalizada = readyForm.nome;
      }
      this.selectPiece(ficha.length ? 0 : null);
      this.processFinalPrice();
    },
    clearAssembly() {
      this.product.ficha_tecnica = [];
      this.selectedPieceIndex = null;
      this.selectedReadyForm = null;
      this.processFinalPrice();
    },
    hasMissingDimensions(item) {
      if (!this.isStonePiece(item.type)) return false;
      const comprimento = this.toNumber(item.comprimento);
      const largura = this.toNumber(item.largura);
      return comprimento <= 0 || largura <= 0;
    },
    updateFichaItem(item, index) {
      const platePrice = this.toNumber(this.product.ultimo_preco_de_compra);
      const recalculated = this.recalculateItemTotal(
        this.withPlateThickness({
          ...item,
          comprimento: roundMeasure(item.comprimento),
          largura: roundMeasure(item.largura)
        }),
        platePrice
      );
      this.$set(this.product.ficha_tecnica, index, recalculated);
      this.processFinalPrice();
    },
    verifyUnit(item) {
      if (
        (item.type === "Peça Secundária" || item.type === "Peça Principal") &&
        parseFloat(item.largura) <= 0.1
      ) {
        return "ML";
      } else if (
        (item.type === "Peça Secundária" || item.type === "Peça Principal") &&
        parseFloat(item.largura) > 0.1
      ) {
        return "M²";
      } else if (item.type === "Acabamento") {
        return "UND";
      }
    },
    removeItem(item, i) {
      this.product.ficha_tecnica = this.product.ficha_tecnica.filter(
        (it, index) => index !== i
      );
      if (this.hoverPrimaryIndex === i) {
        this.hoverPrimaryIndex = null;
      }
      if (this.selectedPieceIndex === i) {
        this.selectedPieceIndex = null;
      } else if (this.selectedPieceIndex > i) {
        this.selectedPieceIndex--;
      }
      this.processFinalPrice();
    },
    addFichaTecnica() {
      if (this.$refs.formAddItem.validate()) {
        const type = this.descricao.type;
        if (this.normalizeType(type).includes("forma pronta")) {
          this.selectedReadyForm = this.descricao;
          this.applyReadyForm(this.descricao);
          this.descricao = "";
          this.quantidade = 1;
          return;
        }
        if (
          !this.product.descricao_personalizada &&
          type === "Peça Principal"
        ) {
          this.product.descricao_personalizada = this.descricao.nome;
        }
        const relacaoPrincipal =
          this.descricao.relacao_principal ||
          this.descricao.relacaoPrincipal ||
          "neutra";
        const slabThicknessMm = this.plateThicknessMm();

        if (type && type === "Acabamento") {
          const quantidade = parseInt(this.quantidade);
          const lucro_percentual = parseFloat(
            `${this.taxFinishing}`.replace(",", ".")
          );
          const preco = parseFloat(
            this.descricao.ultimo_preco_de_compra.replace(",", ".")
          );
          const calculo = preco;
          const taxa = (calculo / 100) * lucro_percentual;
          const total = parseFloat(quantidade * (taxa + calculo)).toFixed(2);
          this.product.ficha_tecnica.push({
            comprimento: 0,
            largura: 0,
            preco,
            descricao: this.descricao.nome,
            calculo,
            taxa,
            type: type,
            total,
            quantity: quantidade,
            position: { x: 50, y: 50, z: 0 }
          });
          this.$refs.qtdFicha.focus();
        } else if (
          type &&
          (type === "Peça Principal" || type === "Peça Secundária")
        ) {
          const comprimento = roundMeasure(this.comprimento);
          const quantidade = parseInt(this.quantidade);
          const largura = roundMeasure(this.largura);
          const lucro_percentual = parseFloat(
            `${this.taxFinishing}`.replace(",", ".")
          );
          const preco = parseFloat(
            this.product.ultimo_preco_de_compra.replace(",", ".")
          );
          let calculo, taxa;
          if (largura <= 0.1) {
            let dezporcento = (preco / 100) * 10;
            calculo = quantidade * comprimento * dezporcento;
            taxa = (calculo / 100) * lucro_percentual;
          } else {
            calculo = quantidade * comprimento * largura * preco;
            taxa = (calculo / 100) * lucro_percentual;
          }
          // secundária nasce COLADA e paralela à principal (mesma regra do
          // copilot), conforme a relação do cadastro — nada de cair longe
          const placement =
            type === "Peça Secundária"
              ? this.placementForSecondary(largura, relacaoPrincipal)
              : null;
          this.product.ficha_tecnica.push({
            comprimento: comprimento,
            largura: largura,
            preco,
            descricao: this.descricao.nome,
            calculo,
            type: type,
            taxa,
            total: parseFloat(taxa + calculo).toFixed(2),
            quantity: quantidade,
            edgeFinishType: "polida",
            edgeFinishes: [],
            // relação com a principal vem do CADASTRO do insumo (saia =
            // curvada para baixo etc.) — usada pela perspectiva/impressão
            relacaoPrincipal,
            relacao_principal: relacaoPrincipal,
            slabThicknessMm,
            espessura_mm: slabThicknessMm,
            espessuraMm: slabThicknessMm,
            fichaId: uid("ficha"),
            linkedTo: placement ? placement.linkedTo : null,
            position: placement
              ? placement.position
              : { x: 50, y: 50, z: 0 }
          });
          this.$refs.qtdFicha.focus();
          this.quantidade = 1;
          this.comprimento = "";
          this.largura = "";
          this.descricao = "";
        }
        this.selectPiece(this.product.ficha_tecnica.length - 1);
        this.processFinalPrice();

        //tutorial
        this.$emit('nextStep')
      }
    },
    openPieceTemplateOnboarding(defaultType) {
      this.pieceTemplateStep = 1;
      this.quickPieceTemplateForm = {
        nome: "",
        type: defaultType || this.firstMissingPieceType || "Peça Principal"
      };
      this.pieceTemplateDialog = true;
    },
    closePieceTemplateOnboarding() {
      this.pieceTemplateDialog = false;
      this.pieceTemplateStep = 1;
      this.savingPieceTemplate = false;
      this.quickPieceTemplateForm = {
        nome: "",
        type: this.firstMissingPieceType || "Peça Principal"
      };
    },
    startAnotherPieceTemplate() {
      this.pieceTemplateStep = 1;
      this.quickPieceTemplateForm = {
        nome: "",
        type: this.firstMissingPieceType || "Peça Principal"
      };
    },
    goToPieceTemplateFinalStep() {
      this.pieceTemplateStep = 3;
    },
    async createPieceTemplate() {
      const form = this.$refs.pieceTemplateForm;
      if (form && !form.validate()) {
        return;
      }
      this.savingPieceTemplate = true;
      this.$store.dispatch("enableLoading");
      try {
        await this.$run("insumos/create", {
          nome: this.quickPieceTemplateForm.nome.trim(),
          type: this.quickPieceTemplateForm.type,
          disponivel: true,
          unidade_estoque_minimo: {
            nome: "Metro Quadrado",
            valor: "M2",
            divisor: 100
          },
          preco_multiplo: []
        });
        this.createGlobalMessage({
          type: "success",
          message: "Peca cadastrada com sucesso.",
          timeout: 4000
        });
        this.$emit("refreshProducts");
        this.pieceTemplateStep = 2;
      } catch (error) {
        this.createGlobalMessage({
          type: "error",
          message:
            (error.response && error.response.data && error.response.data.message) ||
            "Nao foi possivel cadastrar a peca. Tente novamente.",
          timeout: 6000
        });
      } finally {
        this.$store.dispatch("disableLoading");
        this.savingPieceTemplate = false;
      }
    },
    ...mapActions([
      "createGlobalMessage"
    ]),
    open(product) {
      if (product.type == 'Assinatura') {
        this.product = {
          ...product,
          ficha_tecnica: product.ficha_tecnica ? product.ficha_tecnica : [],
          quantity: product.quantity ? product.quantity : 1,
          ficha_total_price: product.ultimo_preco_de_compra,
          seller_price: product.ultimo_preco_de_compra
        }
        setTimeout(() => {
          this.addProduct();
        }, 300);
      } else {
        this.opened = true;
        this.selectedReadyForm = null;
        this.cadViewMode = "2d";
        this.hoverPrimaryIndex = null;
        this.product = {
          obra: product.obra || null,
          comodo: product.comodo || null,
          ...product,
          ficha_tecnica: product.ficha_tecnica ? product.ficha_tecnica : [],
          quantity: product.quantity ? product.quantity : 1,
          seller_price: product.quantity
            ? product.seller_price
            : product.preco_com_markup
        };
        this.syncRoomSelection();
        this.product.ficha_tecnica = this.product.ficha_tecnica.map((item, index) =>
          this.withPlateThickness(
            {
              ...item,
              edgeFinishType: item.edgeFinishType || "polida",
              edgeFinishes: Array.isArray(item.edgeFinishes) ? item.edgeFinishes : [],
              position: item.position || {
                x: Math.min(90, 18 + (index % 5) * 12),
                y: Math.min(84, 20 + (index % 5) * 9),
                z: 0
              }
            },
            this.product
          )
        );
        this.selectedPieceIndex = this.product.ficha_tecnica.length ? 0 : null;
      }
    },
    alterProduct(p) {
      let ficha_tecnica = [];
      this.product.ficha_tecnica.map(item => {
        const quantidade = parseInt(item.quantity);
        const lucro_percentual = parseFloat(
          `${this.taxFinishing}`.replace(",", ".")
        );
        const preco = parseFloat(p.ultimo_preco_de_compra.replace(",", "."));

        if (item.type === "Acabamento") {
          const calculo = parseFloat(item.preco);
          const taxa = (calculo / 100) * lucro_percentual;
          item.total = parseFloat(quantidade * (taxa + calculo)).toFixed(2);
          item.preco = parseFloat(item.preco);
          item.calculo = calculo;
          item.taxa = taxa;
        } else if (
          item.type === "Peça Principal" ||
          item.type === "Peça Secundária"
        ) {
          const comprimento = parseFloat(item.comprimento);
          const largura = parseFloat(item.largura);
          //calculo é isso
          let calculo;
          if (largura <= 0.1) {
            let dezporcento = (preco / 100) * 10;
            calculo = comprimento * dezporcento;
          } else {
            calculo = comprimento * largura * preco;
          }
          // até aqui
          const taxa = (calculo / 100) * lucro_percentual;
          item.total = parseFloat(quantidade * (taxa + calculo)).toFixed(2);
          item.preco = preco;
          item.calculo = calculo;
          item.taxa = taxa;
        }
        ficha_tecnica.push(this.withPlateThickness(item, p));
      });
      const slabThicknessMm = this.plateThicknessMm(p);
      this.product = {
        ...this.product,
        ...p,
        slabThicknessMm,
        espessura_mm: slabThicknessMm,
        espessuraMm: slabThicknessMm,
        ficha_tecnica
      };
      this.changePlate = false;
      this.processFinalPrice();
    },
    close() {
      this.opened = false;
      this.selectedReadyForm = null;
      this.selectedPieceIndex = null;
      this.hoverPrimaryIndex = null;
      this.product = {
        quantity: 1,
        imagens: [],
        ficha_tecnica: []
      };
    },
    initChangeTable() {
      this.changePlate = true;
      setTimeout(() => {
        this.$refs.plateInput.focus();
      }, 300);
    },
    addAditional(index_item_adicional, index_adicional) {
      let item_adicional = this.product.adicionais[index_adicional];
      if (
        item_adicional.quantidade_adicionada &&
        item_adicional.quantidade_adicionada < parseInt(item_adicional.maximo)
      ) {
        item_adicional.quantidade_adicionada++;
        item_adicional.itens[index_item_adicional].quantidade_adicionada
          ? item_adicional.itens[index_item_adicional].quantidade_adicionada++
          : (item_adicional.itens[
              index_item_adicional
            ].quantidade_adicionada = 1);
      } else if (
        item_adicional.quantidade_adicionada &&
        item_adicional.quantidade_adicionada === parseInt(item_adicional.maximo)
      ) {
        this.createGlobalMessage({
          type: "info",
          icon: "mdi-info",
          message: "Opa, quantidade máxima atingida!",
          timeout: 6000
        });
      } else if (!item_adicional.quantidade_adicionada) {
        item_adicional.quantidade_adicionada = 1;
        item_adicional.itens[index_item_adicional].quantidade_adicionada = 1;
      }

      this.product.adicionais[index_adicional] = item_adicional;
      this.$forceUpdate();
      this.processFinalPrice();
    },
    removeAditional(index_item_adicional, index_adicional) {
      let item_adicional = this.product.adicionais[index_adicional];
      if (
        item_adicional.quantidade_adicionada &&
        item_adicional.quantidade_adicionada > 1
      ) {
        item_adicional.quantidade_adicionada--;
        item_adicional.itens[index_item_adicional].quantidade_adicionada--;
      } else if (
        item_adicional.quantidade_adicionada &&
        item_adicional.quantidade_adicionada === 1
      ) {
        item_adicional.quantidade_adicionada = 0;
        item_adicional.itens[index_item_adicional].quantidade_adicionada = 0;
      }
      this.product.adicionais[index_adicional] = item_adicional;
      this.processFinalPrice();
    },
    // thiss process product.seller_price
    processFinalPrice() {
      // const aditionals = this.product.adicionais || [];
      const ficha_tecnica = this.product.ficha_tecnica || [];
      let initial_price = 0;
      let aditional_total_price = 0;
      let ficha_total_price = 0;
      // let acabamento_total_price = 0;
      // aditionals.map(adicional => {
      //   adicional.itens.map(item => {
      //     if (item.quantidade_adicionada) {
      //       aditional_total_price +=
      //         parseInt(item.quantidade_adicionada) * parseFloat(item.preco);
      //     }
      //   });
      // });
      ficha_tecnica.map(ficha => {
        if (ficha.quantity) {
          ficha_total_price += parseFloat(ficha.total);
        }
      });
      this.product.seller_price =
        initial_price + aditional_total_price + ficha_total_price;
      // this.product.seller_price =
      //   this.product.quantity *
      //   (initial_price + aditional_total_price + ficha_total_price);
      // this.product.aditional_total_price = aditional_total_price;
      this.product.ficha_total_price = ficha_total_price;
      this.$forceUpdate();
    },
    addProduct(sequencial) {
      const product = this.product;
      this.addProductToCart(product);
      if (sequencial) {
        let sequential_product = {
          ...product,
          descricao_personalizada: "",
          ficha_tecnica: [],
          indexProd: undefined
        };
        this.product = sequential_product;
        setTimeout(() => {
          this.open(sequential_product);
        }, 300);
      }
      this.$emit('nextStep');
    },
    addProductQtd() {
      this.product.quantity++;
      this.processFinalPrice();
    },
    removeProductQtd() {
      if (this.product.quantity > 1) {
        this.product.quantity--;
      }
      this.processFinalPrice();
    }
  },
  computed: {
    ...mapGetters(['get_compra']),
    isDark() {
      return localStorage.dark === "true";
    },
    roomOptions() {
      const rooms = this.get_compra && this.get_compra.obra && Array.isArray(this.get_compra.obra.comodos)
        ? this.get_compra.obra.comodos
        : [];
      return rooms
        .map((room, index) => {
          const label = String(this.roomSelectionValue(room)).trim();
          return {
            key: `${this.normalizeType(label).replace(/\s+/g, "-") || "room"}-${index}`,
            value: label,
            label,
            icon: room && typeof room === "object" && room.icon ? room.icon : this.roomIcon(label)
          };
        })
        .filter(room => room.label);
    },
    readyForms() {
      return this.products.filter(
        i =>
          this.normalizeType(i.type).includes("forma pronta") &&
          i.disponivel !== false
      );
    },
    // acabamentos cadastrados (com imagem) para a paleta do desenho técnico
    drawingFinishCatalog() {
      return this.products.filter(
        i =>
          this.normalizeType(i.type).includes("acabamento") &&
          i.disponivel !== false
      );
    },
    // peças secundárias (saia/rodapé) para a sugestão-fantasma na borda
    drawingSecondaryCatalog() {
      return this.products.filter(
        i =>
          this.normalizeType(i.type).includes("peca secundaria") &&
          i.disponivel !== false
      );
    },
    // furos cadastrados (medidas em cm + símbolo) — dropdown de recortes
    drawingCutoutCatalog() {
      return this.products.filter(
        i => this.normalizeType(i.type) === "furo" && i.disponivel !== false
      );
    },
    modalDrawingExtras() {
      const extras = (this.product && this.product.drawingExtras) || {};
      return {
        elements: Array.isArray(extras.elements) ? extras.elements : [],
        annotations: Array.isArray(extras.annotations) ? extras.annotations : [],
        images: Array.isArray(extras.images) ? extras.images : []
      };
    },
    selectedPiece() {
      if (this.selectedPieceIndex === null || this.selectedPieceIndex === undefined) {
        return null;
      }
      return this.product.ficha_tecnica[this.selectedPieceIndex] || null;
    },
    technicalSummary() {
      const items = this.product.ficha_tecnica || [];
      let area = 0;
      let linear = 0;
      let edges = 0;
      items.forEach(item => {
        const quantity = parseInt(item.quantity) || 1;
        const comprimento = this.toNumber(item.comprimento);
        const largura = this.toNumber(item.largura);
        if (this.isStonePiece(item.type)) {
          if (largura > 0.1) {
            area += quantity * comprimento * largura;
          } else {
            linear += quantity * comprimento;
          }
          edges += Array.isArray(item.edgeFinishes) ? item.edgeFinishes.length : 0;
        }
      });
      return {
        parts: items.length,
        area: area.toFixed(2),
        linear: linear.toFixed(2),
        edges
      };
    },
    plateTextureStyle() {
      if (this.product && this.product.imagens && this.product.imagens[0]) {
        return {
          backgroundImage: `linear-gradient(rgba(8, 8, 8, 0.15), rgba(8, 8, 8, 0.15)), url(${this.product.imagens[0]})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        };
      }
      return {};
    },
    pieceTemplates() {
      return this.products.filter(i => this.isStonePiece(i.type));
    },
    hasPrincipalPieceTemplate() {
      return this.pieceTemplates.some(i => this.isPrimaryPiece(i));
    },
    hasSecondaryPieceTemplate() {
      return this.pieceTemplates.some(
        i => this.normalizeType(i.type).includes("peca secundaria")
      );
    },
    isPieceCatalogIncomplete() {
      return !this.hasPrincipalPieceTemplate || !this.hasSecondaryPieceTemplate;
    },
    firstMissingPieceType() {
      if (!this.hasPrincipalPieceTemplate) return "Peça Principal";
      if (!this.hasSecondaryPieceTemplate) return "Peça Secundária";
      return "Peça Principal";
    },
    adicionais() {
      const payload = this.products.filter(
        i =>
          i.type === "Forma Pronta" ||
          i.type === "Acabamento" ||
          i.type === "Peça Principal" ||
          i.type === "Peça Secundária"
      );

      return payload;
    }
  },
  watch: {
    "get_compra.obra": {
      deep: true,
      handler() {
        this.syncRoomSelection();
      }
    }
  }
};
</script>

<style scoped>
/* ===== desenho técnico em largura total no modal ===== */
.modal-drawing-card {
  background: #ffffff;
  border: 1px solid rgba(7, 94, 84, 0.16);
  border-radius: 12px;
  padding: 8px 10px;
  width: 100%;
}
.modal-drawing-head {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}
.modal-drawing-card--dark {
  background: #111b21;
  border-color: #26343c;
}
/* tela cheia: cobre o viewport INTEIRO (sem borda/vão revelando a tela por
   baixo) — o board vira o único "chrome" visível, por isso o card perde o
   próprio padding/borda/cantos aqui e vira só um contêiner flex */
.modal-drawing-card--expanded {
  background: transparent;
  border: none;
  border-radius: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  overflow: hidden;
  padding: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 250;
}
.modal-drawing-card--expanded ::v-deep .std-root {
  flex: 1 1 auto;
  height: auto !important;
  min-height: 0;
}

.item-list {
  background: #0b0b0b;
  border-radius: 6px;
}
.adicionals::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}

.adicionals::-webkit-scrollbar-track {
  background: rgb(8, 8, 8); /* color of the tracking area */
  border-radius: 6px;
}

.adicionals::-webkit-scrollbar-thumb {
  background-color: #484c4e; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
}
.font-orange {
  color: #e1673c;
}
.ficha-selected {
  border-left: 4px solid #128c7e;
}
.room-selection-stage {
  animation: room-selection-enter .65s cubic-bezier(.22, 1, .36, 1);
  background:
    radial-gradient(circle at 8% 0%, rgba(37, 211, 102, .16), transparent 34%),
    linear-gradient(135deg, rgba(7, 94, 84, .08), rgba(255, 255, 255, .72));
  border: 1px solid rgba(7, 94, 84, .14);
  border-radius: 18px;
  margin-bottom: 12px;
  overflow: hidden;
  padding: 12px;
  position: relative;
}
.room-selection-stage::after {
  animation: room-selection-sweep 1.1s .2s ease-out both;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, .72), transparent);
  content: "";
  inset: 0;
  pointer-events: none;
  position: absolute;
  transform: translateX(-120%);
}
.room-selection-heading {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
}
.room-selection-heading-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.room-selection-eyebrow {
  color: #128c7e;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .12em;
  text-transform: uppercase;
}
.room-selection-heading strong {
  color: #173b33;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.room-selection-heading small {
  color: #667781;
  font-size: 11px;
}
.room-selection-grid {
  display: grid;
  gap: 9px;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  position: relative;
  z-index: 1;
}
.room-selection-card {
  align-items: center;
  animation: room-card-enter .55s calc(var(--room-index) * 70ms) both;
  background: rgba(255, 255, 255, .8);
  border: 1px solid rgba(7, 94, 84, .12);
  border-radius: 15px;
  color: #173b33;
  cursor: pointer;
  display: flex;
  gap: 9px;
  min-height: 66px;
  overflow: hidden;
  padding: 10px;
  position: relative;
  text-align: left;
  transition: border-color .25s ease, box-shadow .25s ease, transform .25s ease, background .25s ease;
}
.room-selection-card:hover {
  border-color: rgba(18, 140, 126, .55);
  box-shadow: 0 10px 24px rgba(7, 94, 84, .14);
  transform: translateY(-3px) scale(1.01);
}
.room-selection-card:focus-visible {
  outline: 3px solid rgba(37, 211, 102, .32);
  outline-offset: 2px;
}
.room-selection-card-selected {
  background: linear-gradient(135deg, rgba(18, 140, 126, .17), rgba(37, 211, 102, .12));
  border-color: #128c7e;
  box-shadow: 0 12px 28px rgba(18, 140, 126, .2), inset 0 0 0 1px rgba(37, 211, 102, .16);
  transform: translateY(-3px);
}
.room-selection-card-glow {
  background: radial-gradient(circle, rgba(37, 211, 102, .42), transparent 68%);
  border-radius: 50%;
  height: 80px;
  opacity: 0;
  position: absolute;
  right: -28px;
  top: -34px;
  transition: opacity .3s ease;
  width: 80px;
}
.room-selection-card-selected .room-selection-card-glow {
  opacity: 1;
}
.room-selection-card-icon {
  align-items: center;
  background: rgba(18, 140, 126, .1);
  border-radius: 12px;
  color: #128c7e;
  display: inline-flex;
  flex: 0 0 auto;
  height: 38px;
  justify-content: center;
  width: 38px;
}
.room-selection-card-selected .room-selection-card-icon {
  background: #128c7e;
  color: #fff;
}
.room-selection-card-copy {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  position: relative;
  z-index: 1;
}
.room-selection-card-copy strong,
.room-selection-card-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.room-selection-card-copy strong {
  font-size: 12px;
}
.room-selection-card-copy small {
  color: #667781;
  font-size: 10px;
  margin-top: 2px;
}
.room-selection-card-check {
  animation: room-check-pop .35s cubic-bezier(.22, 1, .36, 1);
  position: relative;
  z-index: 1;
}
.room-selection-empty {
  align-items: center;
  background: rgba(255, 255, 255, .58);
  border: 1px dashed rgba(7, 94, 84, .22);
  border-radius: 13px;
  color: #667781;
  display: flex;
  font-size: 11px;
  gap: 7px;
  padding: 11px;
  position: relative;
  z-index: 1;
}
.room-selection-stage + .v-timeline-item {
  margin-top: 4px;
}
#modal-adicionar-produto.v-card--dark .room-selection-stage {
  background:
    radial-gradient(circle at 8% 0%, rgba(37, 211, 102, .14), transparent 34%),
    linear-gradient(135deg, rgba(24, 34, 41, .96), rgba(17, 27, 33, .96));
  border-color: rgba(155, 231, 189, .16);
}
#modal-adicionar-produto.v-card--dark .room-selection-heading strong,
#modal-adicionar-produto.v-card--dark .room-selection-card {
  color: #eef4f1;
}
#modal-adicionar-produto.v-card--dark .room-selection-heading small,
#modal-adicionar-produto.v-card--dark .room-selection-card-copy small,
#modal-adicionar-produto.v-card--dark .room-selection-empty {
  color: #9bb4aa;
}
#modal-adicionar-produto.v-card--dark .room-selection-card {
  background: rgba(24, 34, 41, .92);
  border-color: rgba(155, 231, 189, .12);
}
#modal-adicionar-produto.v-card--dark .room-selection-card-selected {
  background: linear-gradient(135deg, rgba(18, 140, 126, .28), rgba(37, 211, 102, .14));
  border-color: #25d366;
}
#modal-adicionar-produto.v-card--dark .room-selection-empty {
  background: rgba(24, 34, 41, .72);
  border-color: rgba(155, 231, 189, .2);
}
@keyframes room-selection-enter {
  from { opacity: 0; transform: translateY(12px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes room-selection-sweep {
  to { transform: translateX(120%); }
}
@keyframes room-card-enter {
  from { opacity: 0; transform: translateY(14px) rotateX(-8deg); }
  to { opacity: 1; transform: translateY(0) rotateX(0); }
}
@keyframes room-check-pop {
  from { opacity: 0; transform: scale(.45) rotate(-18deg); }
  to { opacity: 1; transform: scale(1) rotate(0); }
}
.cad-card {
  background:
    radial-gradient(circle at top right, rgba(7, 94, 84, 0.08), transparent 34%),
    #ffffff;
  border-radius: 18px !important;
  border: 1px solid rgba(7, 94, 84, 0.14) !important;
  box-shadow: 0 18px 38px rgba(7, 94, 84, 0.10);
  overflow: hidden;
}
.cad-card-heading,
.cad-toolbar {
  display: flex;
  align-items: center;
  width: 100%;
}
.cad-toolbar {
  padding: 2px 4px;
}
.cad-toolbar-title {
  color: #075e54;
  font-size: 14px;
  letter-spacing: -0.01em;
}
.cad-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}
.cad-summary-item {
  padding: 8px 10px;
  border-radius: 14px;
  background: #f3f8f5;
  border: 1px solid rgba(7, 94, 84, 0.10);
  display: flex;
  flex-direction: column;
}
.cad-summary-item span {
  color: #667781;
  font-size: 10px;
}
.cad-summary-item strong {
  color: #173b33;
  font-size: 13px;
}
.cad-canvas {
  position: relative;
  width: 100%;
  height: 300px;
  border-radius: 18px;
  border: 1px solid rgba(7, 94, 84, 0.16);
  overflow: hidden;
  background-color: #eef3f0;
  background-image:
    linear-gradient(rgba(7, 94, 84, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(7, 94, 84, 0.06) 1px, transparent 1px);
  background-size: 18px 18px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}
.cad-3d {
  perspective: 900px;
}
.cad-3d-stage {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transform: rotateX(55deg) rotateZ(-15deg);
}
.cad-piece {
  position: absolute;
  border-radius: 8px;
  color: #ffffff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.42);
  background-image:
    linear-gradient(135deg, rgba(255, 255, 255, 0.18), rgba(0, 0, 0, 0.12));
}
.technical-piece::before {
  content: "";
  position: absolute;
  inset: 6px;
  border: 1px dashed rgba(255, 255, 255, 0.42);
  border-radius: 5px;
  pointer-events: none;
}
.technical-piece-label {
  position: relative;
  z-index: 2;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.28);
  font-weight: 700;
}
.technical-piece--secondary {
  opacity: 0.92;
}
.cad-piece-3d {
  transform-style: preserve-3d;
  min-width: 44px;
}
.cad-piece--finish {
  border-radius: 999px;
}
.cad-piece--active {
  outline: 3px solid #fbae1d;
  outline-offset: 3px;
  z-index: 5;
}
.technical-dimension {
  position: absolute;
  z-index: 3;
  color: #173b33;
  background: #ffffff;
  border: 1px solid rgba(7, 94, 84, 0.18);
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  padding: 1px 5px;
  box-shadow: 0 6px 14px rgba(7, 94, 84, 0.14);
  white-space: nowrap;
}
.technical-dimension-top {
  left: 50%;
  top: -22px;
  transform: translateX(-50%);
}
.technical-dimension-side {
  right: -28px;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
}
.technical-edge-marker {
  position: absolute;
  z-index: 4;
  background: rgba(255, 255, 255, 0.36);
  border: 1px dashed rgba(255, 255, 255, 0.50);
  transition: all 0.16s ease;
}
.technical-edge-marker.active {
  background: #fbae1d;
  border-color: #fff2c7;
  box-shadow: 0 0 0 2px rgba(251, 174, 29, 0.24);
}
.technical-edge-front {
  left: 9px;
  right: 9px;
  bottom: 4px;
  height: 5px;
  border-radius: 999px;
}
.technical-edge-back {
  left: 9px;
  right: 9px;
  top: 4px;
  height: 5px;
  border-radius: 999px;
}
.technical-edge-left {
  left: 4px;
  top: 9px;
  bottom: 9px;
  width: 5px;
  border-radius: 999px;
}
.technical-edge-right {
  right: 4px;
  top: 9px;
  bottom: 9px;
  width: 5px;
  border-radius: 999px;
}
.technical-piece-3d::after {
  content: "";
  position: absolute;
  left: 8px;
  right: -10px;
  bottom: -10px;
  height: 12px;
  border-radius: 0 0 8px 8px;
  background: rgba(0, 0, 0, 0.26);
  transform: skewX(-35deg);
  z-index: -1;
}
.cad-hover-hint {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
  padding: 6px 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  color: #1f1f1f;
  font-size: 11px;
  border: 1px solid #d2d2d2;
}
.technical-edge-panel {
  border-radius: 16px;
  padding: 10px;
  background: #f3f8f5;
  border: 1px solid rgba(7, 94, 84, 0.10);
}
.edge-selector-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}
.edge-selector-btn {
  min-width: 0 !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  color: #075e54 !important;
  border: 1px solid rgba(7, 94, 84, 0.12);
}
.edge-selector-btn.active {
  background: #075e54 !important;
  color: #ffffff !important;
}
.technical-finish-note {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 14px;
  padding: 10px;
  background: #f3f8f5;
  border: 1px solid rgba(7, 94, 84, 0.10);
}
.piece-empty-state {
  border: 1px solid #dbeafe !important;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
}
.piece-onboarding-card {
  border-radius: 18px;
  background:
    radial-gradient(circle at top right, rgba(37, 211, 102, 0.10), transparent 34%),
    #ffffff !important;
  color: #173b33 !important;
  border: 1px solid rgba(7, 94, 84, 0.12);
  overflow: hidden;
}
.piece-onboarding-card-dark {
  background:
    radial-gradient(circle at top right, rgba(37, 211, 102, 0.08), transparent 34%),
    #111b21 !important;
  color: #e9edef !important;
  border-color: #26343c;
  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.36);
}
.piece-onboarding-card ::v-deep .v-card__title,
.piece-onboarding-card ::v-deep .v-card__text,
.piece-onboarding-card ::v-deep .v-card__actions {
  background: transparent !important;
}
.piece-onboarding-card-dark ::v-deep .v-divider {
  border-color: #26343c !important;
}
.piece-onboarding-card-dark ::v-deep .fonte,
.piece-onboarding-card-dark ::v-deep h3,
.piece-onboarding-card-dark ::v-deep .v-label,
.piece-onboarding-card-dark ::v-deep .v-input input,
.piece-onboarding-card-dark ::v-deep .v-select__selection,
.piece-onboarding-card-dark ::v-deep .v-icon {
  color: #e9edef !important;
}
.piece-onboarding-card-dark ::v-deep .grey--text {
  color: #8ea39a !important;
}
.piece-onboarding-card-dark ::v-deep .v-input__slot,
.piece-onboarding-card-dark ::v-deep .v-text-field--outlined fieldset {
  background: #182229 !important;
  border-color: #314249 !important;
}
.piece-success-avatar {
  background: #e6f9f0 !important;
  box-shadow: 0 14px 28px rgba(15, 157, 88, 0.16);
}
.piece-success-icon {
  color: #0f9d58 !important;
}
.piece-info-avatar {
  background: #eef2ff !important;
  box-shadow: 0 14px 28px rgba(50, 82, 134, 0.14);
}
.piece-info-icon {
  color: #325286 !important;
}
.piece-onboarding-card-dark .piece-success-avatar {
  background: rgba(37, 211, 102, 0.14) !important;
}
.piece-onboarding-card-dark .piece-success-icon {
  color: #9be7bd !important;
}
.piece-onboarding-card-dark .piece-info-avatar {
  background: rgba(142, 163, 154, 0.16) !important;
}
.piece-onboarding-card-dark .piece-info-icon {
  color: #c9d7d0 !important;
}
</style>
